import clsx from 'clsx';
import React, { ReactNode, useContext, useEffect, useState } from 'react'
import { AppGeneralContext } from '../../shared/GeneralContext/GeneralContext';
import './CardPreview.css'
import logoDefault from './../../assets/logo192.png'
import { Logo } from './iconsComponent';
import { chatDepartmentFormat, formatTitle } from 'shared/utils/formatFunction';
import useMediaQuery from 'hook/useMediaQuery';
import { MediaDesktop, MediaTablet } from 'api/const/MediaQuery';
import useMediaQueryMinMax from 'hook/useMediaQueryMinMax';

export interface previewProps {
  id: string;
  recipient: string;
  date: string;
  readMatch: boolean;
  lastMessageRead?: boolean;
  hasImage: boolean;
  department?: string;
  callback: () => void;
}

const CardPreview = ({ id, recipient, date, department, hasImage, callback, readMatch }: previewProps) => {
 const desktop = useMediaQuery(MediaDesktop)
 const tablet = useMediaQuery(MediaTablet)


  const [data, setData] = useState<Date>()
  const { matchSelected } = useContext(AppGeneralContext)

  useEffect(() => {
    if (date) {
      setData(new Date(date))
    }
  }, [date])

  return (
    <div className={clsx(
      "d-flex flex-row w-100  p-1 preview justify-content-between ",
      { "notRead-item notRead-color": !readMatch && matchSelected?.id !== id },
      { "selected-item selected-color ": matchSelected?.id === id },
      { "read-item read-color": readMatch && matchSelected?.id !== id }
    )}
      onClick={() => callback()}>

      {hasImage && <div className='icon_logo d-flex align-items-center  justify-content-center '>
        <Logo
          colorLogo={!readMatch && matchSelected?.id !== id ? "#FF406B" :
            matchSelected?.id === id ? "#FFFFFF " :
              readMatch && matchSelected?.id !== id ? "#979797d4 " :
                "#FF406B"}
        />
      </div>}
      <div className="d-flex flex-row h-100 w-100 pt-1 pe-1  justify-content-between ">
        <div className='d-flex   flex-column justify-content-center ps-1 date-company__name ' >
          <span className={clsx(
            "nameSender",
            { "notRead-color": !readMatch && matchSelected?.id !== id },
            { "selected-color": matchSelected?.id === id },
            { "read-color": readMatch && matchSelected?.id !== id }
          )}>
            {formatTitle(recipient, tablet && !desktop ? 13 : !tablet && desktop ? 12 : 10)}
          </span>
          <b className={clsx(
            "department-font ",
            { "selected-color": matchSelected?.id === id },
            { "": !readMatch && matchSelected?.id !== id },
            { "read-color": readMatch && matchSelected?.id !== id }
          )}>
            {department ? chatDepartmentFormat(department) : ""}
          </b>
        </div>
        <div className='d-flex justify-content-center flex-column h-100 align-items-end  pb-1 pt-1  '>
          <span className='d-flex align-items-center date-company__date h-50 text-end '>{data?.toLocaleDateString()}</span>
          <span className='d-flex align-items-center last-message h-50  text-end '>{data?.toLocaleTimeString()}</span>
        </div>
      </div>
    </div>
  )
}

export default CardPreview